import { lazy, Suspense } from 'react';
import { css } from 'styled-system/css';
import { AccessSignupForm } from '../AccessSignupForm';
import { Container } from '../Container';
import { Reveal } from '../Reveal';

const PrismSheet = lazy(() =>
  import('./PrismSheet').then((m) => ({ default: m.PrismSheet })),
);

export function HeroSection() {
  return (
    <section
      aria-label="Introduction"
      className={css({
        position: 'relative',
        overflow: 'clip',
        minHeight: '100vh',
        paddingTop: { base: '28', md: '36' },
        paddingBottom: { base: '16', md: '24' },
      })}
    >
      <div
        aria-hidden="true"
        className={css({
          position: 'absolute',
          inset: 0,
          zIndex: 0,
          pointerEvents: 'none',
        })}
      >
        <div
          className={css({
            position: 'absolute',
            top: '10%',
            right: 0,
            width: { base: '100%', md: '75%' },
            height: { base: '70%', md: '80%' },
            _before: {
              content: '""',
              position: 'absolute',
              inset: 0,
              zIndex: 1,
              pointerEvents: 'none',
              backgroundImage:
                'linear-gradient(0deg, token(colors.bg.page), transparent 10%), linear-gradient(180deg, token(colors.bg.page), transparent 30%), linear-gradient(90deg, token(colors.bg.page), transparent 60%)',
            },
          })}
        >
          <Suspense fallback={null}>
            <PrismSheet
              className={css({
                display: 'block',
                width: '100%',
                height: '100%',
              })}
            />
          </Suspense>
        </div>
      </div>

      <Container className={css({ position: 'relative', zIndex: 1 })}>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            textAlign: 'left',
          })}
        >
          <Reveal>
            <h1
              className={css({
                textStyle: 'display',
                fontSize: 'clamp(2.5rem, 7vw, 5.75rem)',
                color: 'text.primary',
                maxWidth: '16ch',
                marginTop: { base: '10', md: '16' },
              })}
            >
              Automate your spreadsheets
            </h1>
          </Reveal>

          <Reveal delay={160}>
            <p
              className={css({
                fontSize: { base: 'base', md: 'md' },
                color: 'text.secondary',
                lineHeight: 'relaxed',
                maxWidth: '450px',
                marginTop: '6',
              })}
            >
              Exis adds agents to your spreadsheets. AI updates your data,
              catches errors, and fills patterns. You remain in full control,
              with proposals and reviews.
            </p>
          </Reveal>

          <Reveal
            delay={240}
            className={css({
              width: '100%',
              marginTop: '8',
            })}
          >
            <AccessSignupForm idPrefix="hero" />
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
